module.exports = __webpack_public_path__ + "img/product_6.386b7e6.webp";